var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewmyactivity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.89 6.26993L11.89 6.26992L11.1943 5.73064L11.1548 5.70001L11.1548 5.70001L9.87812 7.34691C9.84798 7.38389 9.79011 7.39238 9.74871 7.36119L8.73808 6.56596L8.73805 6.56593L8.7352 6.56369L8.73521 6.56369L8.73482 6.56339C8.28855 6.21855 7.6476 6.29934 7.30193 6.74668L7.30189 6.74674L5.98415 8.45756L5.98415 8.45757C5.82741 8.6611 5.86531 8.95314 6.06882 9.10991L6.06883 9.10992C6.27234 9.26663 6.56438 9.22874 6.72114 9.02526L6.72114 9.02526L8.03756 7.3161C8.03779 7.31581 8.03801 7.31554 8.03821 7.31527L8.03895 7.31585L8.04089 7.31197C8.07195 7.27553 8.12565 7.26909 8.16504 7.29877L9.17565 8.094L9.17569 8.09403L9.17853 8.09627L9.17853 8.09627L9.17892 8.09657C9.62413 8.44055 10.2624 8.3608 10.6087 7.92291L10.609 7.92253L11.89 6.26993ZM8.04859 7.28476H7.99859C8.0092 7.27107 8.02179 7.25985 8.03566 7.25121C8.03959 7.25555 8.04204 7.2598 8.04349 7.26276C8.04588 7.26765 8.04698 7.27191 8.0475 7.27441C8.04854 7.2793 8.04859 7.28324 8.04859 7.28476ZM8.19558 7.25919C8.14713 7.22237 8.0838 7.22123 8.0357 7.25118L8.19558 7.25919Z",
    stroke: "#97A6A5",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66821 14.3364C12.351 14.3364 15.3364 11.351 15.3364 7.66821C15.3364 3.98546 12.351 1 8.66821 1C4.98546 1 2 3.98546 2 7.66821C2 11.351 4.98546 14.3364 8.66821 14.3364Z",
    stroke: "#97A6A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0008 16.0035L13.375 12.3776",
    stroke: "#97A6A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewmyactivity);
export default __webpack_public_path__ + "static/media/reviewmyactivity.dd93cb7964e426223f2c8698f86d5bcc.svg";
export { ForwardRef as ReactComponent };